import { Level2MenuHead, Level2MenuItem } from "@/features";
import { MdOutlineAccountCircle } from "react-icons/md";
import React, { ReactElement, useContext } from "react";
import { useTextDomainContext } from "@/app/providers";
import {
  permissionsAllowToAll,
  permissionsDeveloper,
  permissionsSettings,
} from "@/utils";

const parentPath = "user-account";

export const MyAccountMenu = (): ReactElement => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  return (
    <Level2MenuHead
      link={`/${parentPath}`}
      label={gettext("My Account")}
      codes={permissionsAllowToAll}
      feature="common"
      icon={<MdOutlineAccountCircle size={18} className="mx-3" />}
    >
      <Level2MenuItem
        link={`/${parentPath}/profile`}
        label={gettext("My Profile")}
        codes={permissionsAllowToAll}
        feature="common"
      />
      <Level2MenuItem
        link={`/${parentPath}/products`}
        label={gettext("Products")}
        codes={permissionsDeveloper}
        feature="common"
      />
      <Level2MenuItem
        link={`/${parentPath}/services`}
        label={gettext("Services")}
        codes={permissionsDeveloper}
        feature="common"
      />
      <Level2MenuItem
        link={`/${parentPath}/notifications`}
        label={gettext("Notifications")}
        codes={permissionsAllowToAll}
        feature="common"
      />
      <Level2MenuItem
        link={`/${parentPath}/settings`}
        label={gettext("Settings")}
        codes={permissionsSettings}
        feature="common"
      />
    </Level2MenuHead>
  );
};
